import {
  LucideAlertTriangle,
  LucideBell,
  LucideCheckCircle,
  LucideDollarSign,
  LucideFileText,
  LucidePackage,
  LucideShield,
  LucideTruck,
  LucideUserCheck,
  LucideUserPlus,
  LucideXCircle,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

const iconMap: Record<string, LucideIcon> = {
  truck: LucideTruck,
  'file-text': LucideFileText,
  package: LucidePackage,
  'dollar-sign': LucideDollarSign,
  'alert-triangle': LucideAlertTriangle,
  'user-check': LucideUserCheck,
  'user-plus': LucideUserPlus,
  'check-circle': LucideCheckCircle,
  'x-circle': LucideXCircle,
  shield: LucideShield,
};

export function getNotificationIcon(iconName?: string): LucideIcon {
  if (!iconName) return LucideBell;
  return iconMap[iconName] ?? LucideBell;
}

const typeIconByKey: Record<string, string> = {
  'booking.status_changed': 'truck',
  'load.shipped': 'truck',
  'load.reconciled': 'truck',
  'load.voided': 'truck',
  'purchase_order.voided': 'file-text',
  'purchase_order.closed': 'file-text',
  'purchase_load.received': 'package',
  'purchase_load.voided': 'package',
  'invoice.paid': 'dollar-sign',
  'invoice.voided': 'dollar-sign',
  'bill.paid': 'dollar-sign',
  'bill.voided': 'dollar-sign',
  'task.failed': 'alert-triangle',
  'task.assigned_to_driver': 'user-check',
  'task.assigned_to_hauler': 'truck',
  'route.failed': 'alert-triangle',
  'route.completed': 'check-circle',
  'route.cancelled': 'x-circle',
  'user.added_to_organization': 'user-plus',
  'user_role.assigned': 'shield',
  'sales_order.status_changed': 'file-text',
};

export function getNotificationIconByKey(typeKey: string): LucideIcon {
  const iconName = typeIconByKey[typeKey];
  return getNotificationIcon(iconName);
}
